import { createContext, Dispatch, ReactElement, SetStateAction, useState } from 'react'

export const GuestKeyContext = createContext<{
  guestKey: string
  setGuestKey: Dispatch<SetStateAction<string>>
}>({
  guestKey: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
  setGuestKey: () => {},
})

interface IGuestKeyContextProvider {
  children: ReactElement
  defaultValue: string
}

export const GuestKeyContextProvider = ({ children, defaultValue }: IGuestKeyContextProvider) => {
  const [guestKey, setGuestKey] = useState<string>(defaultValue)

  return <GuestKeyContext.Provider value={{ guestKey, setGuestKey }}>{children}</GuestKeyContext.Provider>
}
